export const ThousandSeparator = (num, withRp = false) => {
    if (num) {
        return (withRp ? 'Rp. ' : '') + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ',-';
    }
    return null;
}